import React from 'react'
import { useTranslation } from 'react-i18next'
import { baseUrl } from '@fs/zion-config'
import { Link } from '@fs/zion-router'
import { i18n } from '@fs/zion-locale'
import PropTypes from 'prop-types'

export default function AccessibilityLink({ external }) {
  const [t] = useTranslation()

  // TODO: we should not be hand crafting a url with a language like this.
  return (
    <div>
      <Link
        isGray
        external
        wayfinding
        to={`${external ? baseUrl : ''}/${i18n.language}/about/accessibility-statement`}
        linkName="accessibility_statement"
      >
        {t('footer.accessibility-support', 'Accessibility Support')}
      </Link>
    </div>
  )
}

AccessibilityLink.propTypes = {
  external: PropTypes.bool,
}
